function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import moment from "moment-timezone";
import { FilterContext, UserContext } from "../index";
import Select from "react-select";
import { GET_ALL_ORGANISATION_DATAS_QUERY, GET_USER_DATA_QUERY, EDIT_USER_WORK_DETAILS_MUTATION, TEAM_LIST_FOR_USER_QUERY } from "./query";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import DatePicker from "react-datepicker";
import Table from "react-bootstrap/Table";
import "./EditTimesheet.css";
import Loader from "../Loader/Loader";
import Button from "react-bootstrap/Button";
import TimePicker from "rc-time-picker";
// import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import { ORGANISATION_TEAMS_QUERY } from "../SideMenu/query";
import SearchBar from "../SearchBar";
import Modal from "react-bootstrap/Modal";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import ControlLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Popover from "react-bootstrap/Popover";
import { TIMESHEET_QUERY } from "../TimeSheet/query";
import { convertSecToHoursAndMinutesWithTextShortForm, isRateLimited, rateLimitMessage } from "../utils";
var LIMIT = 10;
var offsets = 0;
var UserSchema = Yup.object().shape({
  teamId: Yup.string().trim().required("Pls select atleast one team")
});
var findYesterdayDate = function findYesterdayDate() {
  var date = new Date();
  date.setDate(date.getDate() - 1);
  return date;
};
var EditTimesheet = function EditTimesheet(props) {
  var _React$useContext = React.useContext(FilterContext),
    organisationId = _React$useContext.organisationId,
    organisationSettings = _React$useContext.organisationSettings,
    from = _React$useContext.from,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling;
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;
  var date = findYesterdayDate;
  var _React$useState = React.useState(date),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    startDate = _React$useState2[0],
    setStartDate = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    userSearch = _React$useState4[0],
    setUserSearch = _React$useState4[1];
  var Redirect = props.redirect,
    match = props.match,
    Link = props.linkComponent,
    linkProps = props.linkProps,
    dateFilter = props.dateFilter,
    timezoneFilter = props.timezoneFilter;
  React.useEffect(function () {
    if (from == "web" && role == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped" && role != "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    } else if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free") {
      props === null || props === void 0 ? void 0 : props.history.push("/timesheet");
    }
  }, [organisationBilling]);

  //   const {
  //     data: organisationData,
  //     error: organisationError,
  //     loading: organisationLoading,
  //   } = useQuery(GET_ALL_ORGANISATION_DATAS_QUERY, {
  //     variables: {
  //       limit: LIMIT,
  //       offset,
  //     },
  //   });

  //   console.log({ organisationData, error: organisationError, loading: organisationLoading });

  //   let organisationList = [];
  //   organisationData?.getAllOrganisationDatas?.map((item) => {
  //     const { organisationId, organisationName } = item;
  //     return organisationList.push({
  //       label: organisationName,
  //       value: organisationId,
  //     });
  //   });

  //   const startDateFormat = Number(moment(startDate).startOf("day").format("x"));

  var _useQuery = useQuery(GET_USER_DATA_QUERY, {
      variables: {
        organisationId: organisationId,
        date: moment(startDate).format("YYYY-MM-DD"),
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        limit: LIMIT,
        offset: 0,
        userSearch: userSearch
      }
    }),
    userDetails = _useQuery.data,
    userError = _useQuery.error,
    userLoading = _useQuery.loading,
    userRefetch = _useQuery.refetch,
    fetchMore = _useQuery.fetchMore;
  var _useQuery2 = useQuery(ORGANISATION_TEAMS_QUERY, {
      variables: {
        organisationId: organisationId,
        from: "web"
      }
    }),
    teamData = _useQuery2.data,
    teamError = _useQuery2.error,
    teamLoading = _useQuery2.loading;
  React.useEffect(function () {
    userRefetch === null || userRefetch === void 0 ? void 0 : userRefetch();
  }, [userSearch]);
  return /*#__PURE__*/React.createElement("div", {
    className: "edit-user-details-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "edit-user-details-filter-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "edit-user-details-date-picker"
  }, " ", /*#__PURE__*/React.createElement(DatePicker, {
    selected: startDate,
    onChange: function onChange(date) {
      return setStartDate(date);
    },
    dateFormat: "dd MMM, yyyy",
    maxDate: moment().subtract(1, "day").toDate(),
    className: "edit-user-details-date-picker-change"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SearchBar, {
    value: userSearch,
    onChange: setUserSearch,
    placeholder: "Search by name, email",
    className: "edit-user-details-user-search"
  }))), /*#__PURE__*/React.createElement(UserWorkedDetails, {
    userDetails: userDetails,
    userError: userError,
    userLoading: userLoading,
    fetchMore: fetchMore,
    startDate: startDate,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    organisationId: organisationId,
    teamData: teamData === null || teamData === void 0 ? void 0 : teamData.organisationTeams,
    teamLoading: teamLoading,
    userSearch: userSearch,
    Link: Link,
    linkProps: linkProps,
    user: user,
    timezoneFilter: !timezoneFilter ? null : timezoneFilter,
    dateFilter: dateFilter
  }));
};
var UserWorkedDetails = function UserWorkedDetails(props) {
  var _userDetails$getUserD, _userDetails$getUserD2, _userDetails$getUserD3, _userDetails$getUserD4;
  var userDetails = props.userDetails,
    userError = props.userError,
    userLoading = props.userLoading,
    fetchMore = props.fetchMore,
    startDate = props.startDate,
    timeZone = props.timeZone,
    organisationId = props.organisationId,
    teamData = props.teamData,
    userSearch = props.userSearch,
    Link = props.Link,
    linkProps = props.linkProps,
    user = props.user,
    timezoneFilter = props.timezoneFilter,
    dateFilter = props.dateFilter;
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isAllLoaded = _React$useState6[0],
    setIsAllLoaded = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isLoadingMore = _React$useState8[0],
    setIsLoadingMore = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isLoadMoreButton = _React$useState10[0],
    setIsLoadMoreButton = _React$useState10[1];
  var _React$useState11 = React.useState(null),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    editUserModalShow = _React$useState12[0],
    setEditUserModalShow = _React$useState12[1];
  if ((userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$getUserD = userDetails.getUserData) === null || _userDetails$getUserD === void 0 ? void 0 : _userDetails$getUserD.length) !== 0 && (userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$getUserD2 = userDetails.getUserData) === null || _userDetails$getUserD2 === void 0 ? void 0 : _userDetails$getUserD2.length) < LIMIT && !isAllLoaded) {
    setIsAllLoaded(true);
  }
  var handleEditUserModalClose = function handleEditUserModalClose() {
    setEditUserModalShow(null);
  };
  var handleEditUserModalShow = function handleEditUserModalShow(data) {
    var temp = _objectSpread({}, data);
    setEditUserModalShow(temp);
  };
  var handleLoadMore = function handleLoadMore() {
    if (userLoading) return;
    setIsLoadingMore(true);
    offsets = offsets + 1;
    fetchMore({
      variables: {
        offset: offsets * LIMIT
      },
      updateQuery: function updateQuery(prev, _ref) {
        var _fetchMoreResult$getU, _fetchMoreResult$getU2;
        var fetchMoreResult = _ref.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$getU = fetchMoreResult.getUserData) === null || _fetchMoreResult$getU === void 0 ? void 0 : _fetchMoreResult$getU.length) === 0 && ((_fetchMoreResult$getU2 = fetchMoreResult.getUserData) === null || _fetchMoreResult$getU2 === void 0 ? void 0 : _fetchMoreResult$getU2.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          getUserData: [].concat(_toConsumableArray(prev.getUserData), _toConsumableArray(fetchMoreResult.getUserData))
        });
      }
    });
  };
  var OSType = null;
  if (window.navigator.userAgent.indexOf("Windows") != -1) {
    OSType = "windows";
  } else if (window.navigator.userAgent.indexOf("Mac OS") != -1) {
    OSType = "mac";
  } else if (window.navigator.userAgent.indexOf("Linux") != -1) {
    OSType = "linux";
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "edit-user-details-div-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "edit-user-details-div-root ".concat(OSType == "windows" ? "edit-user-details-div-root-windows-scroll" : "")
  }, /*#__PURE__*/React.createElement(Table, {
    bordered: true,
    className: "edit-user-details-root-content-table "
  }, /*#__PURE__*/React.createElement("thead", {
    className: "edit-user-details-root-content-data-header"
  }, /*#__PURE__*/React.createElement("tr", {
    className: "edit-user-details-root-content-data-header-tr"
  }, /*#__PURE__*/React.createElement("th", {
    className: "edit-user-details-root-content-th-sticky-col first-col"
  }, "Employees"), /*#__PURE__*/React.createElement("th", {
    className: "edit-user-details-root-content-th-sticky-col second-column"
  }, "Action"), /*#__PURE__*/React.createElement("th", null, "Team"), /*#__PURE__*/React.createElement("th", null, "Clock In"), /*#__PURE__*/React.createElement("th", null, "Clock Out"), /*#__PURE__*/React.createElement("th", null, "Total Worked Time"), /*#__PURE__*/React.createElement("th", null, "Idle Time"), /*#__PURE__*/React.createElement("th", null, "Productive Time"), /*#__PURE__*/React.createElement("th", null, "Unproductive Time"), /*#__PURE__*/React.createElement("th", null, "Neutral Time"), /*#__PURE__*/React.createElement("th", null, "Break Time"), /*#__PURE__*/React.createElement("th", null, "Untracked Time"))), /*#__PURE__*/React.createElement("tbody", {
    className: "edit-user-details-root-table-body"
  }, userLoading ? /*#__PURE__*/React.createElement(Loader, null) : userError ? /*#__PURE__*/React.createElement("div", null, "Something went wrong!!") : userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$getUserD3 = userDetails.getUserData) === null || _userDetails$getUserD3 === void 0 ? void 0 : _userDetails$getUserD3.map(function (userValues, key) {
    var _userValues$user, _userValues$user2, _userValues$user3, _userValues$user4, _userValues$user5, _userValues$user6, _userValues$team;
    return /*#__PURE__*/React.createElement("tr", {
      className: "edit-user-details-root-content-data-details",
      key: key
    }, /*#__PURE__*/React.createElement("td", {
      className: "edit-user-details-root-content-th-sticky-col first-col"
    }, " ", /*#__PURE__*/React.createElement("div", {
      className: "edit-employees-root-content-data-details-avatar"
    }, userValues !== null && userValues !== void 0 && (_userValues$user = userValues.user) !== null && _userValues$user !== void 0 && _userValues$user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "employee-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: userValues === null || userValues === void 0 ? void 0 : (_userValues$user2 = userValues.user) === null || _userValues$user2 === void 0 ? void 0 : _userValues$user2.profileUrl,
      className: "team-card-avatar-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "edit-employees-root-content-data-details-avatar-circle text-white"
    }, userValues === null || userValues === void 0 ? void 0 : (_userValues$user3 = userValues.user) === null || _userValues$user3 === void 0 ? void 0 : _userValues$user3.displayName.charAt(0)), /*#__PURE__*/React.createElement("div", {
      className: "edit-employees-root-content-data-details-name-data"
    }, " ", /*#__PURE__*/React.createElement(Link, _extends({}, _defineProperty({}, linkProps, "/personal-statistics/".concat(userValues === null || userValues === void 0 ? void 0 : (_userValues$user4 = userValues.user) === null || _userValues$user4 === void 0 ? void 0 : _userValues$user4.uniqueUrl)), {
      key: "employee-".concat(userValues === null || userValues === void 0 ? void 0 : (_userValues$user5 = userValues.user) === null || _userValues$user5 === void 0 ? void 0 : _userValues$user5.uniqueUrl)
    }), userValues === null || userValues === void 0 ? void 0 : (_userValues$user6 = userValues.user) === null || _userValues$user6 === void 0 ? void 0 : _userValues$user6.displayName), " "))), /*#__PURE__*/React.createElement("td", {
      className: "edit-user-details-root-content-th-sticky-col second-column"
    }, " ", /*#__PURE__*/React.createElement(Button, {
      variant: "outline-primary",
      className: "edit-user-details-root-content-td-edit-button",
      onClick: function onClick() {
        handleEditUserModalShow(_objectSpread(_objectSpread({}, userValues), {}, {
          startDate: startDate
        }));
      }
    }, "Edit")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "edit-user-details-list-worked-time"
    }, " ", userValues === null || userValues === void 0 ? void 0 : (_userValues$team = userValues.team) === null || _userValues$team === void 0 ? void 0 : _userValues$team.teamName)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "edit-user-details-list-time"
    }, userValues !== null && userValues !== void 0 && userValues.clockIn ? moment(Number(userValues === null || userValues === void 0 ? void 0 : userValues.clockIn)).format("hh:mm A") : "")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "edit-user-details-list-time"
    }, userValues !== null && userValues !== void 0 && userValues.clockOut ? moment(Number(userValues === null || userValues === void 0 ? void 0 : userValues.clockOut)).format("hh:mm A") : "")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "edit-user-details-list-worked-time"
    }, userValues === null || userValues === void 0 ? void 0 : userValues.totalTimeSpentInSec)), /*#__PURE__*/React.createElement("td", null, " ", /*#__PURE__*/React.createElement("div", {
      className: "edit-user-details-list-worked-time"
    }, userValues === null || userValues === void 0 ? void 0 : userValues.idleSec)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "edit-user-details-list-worked-time"
    }, userValues === null || userValues === void 0 ? void 0 : userValues.productiveSec)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "edit-user-details-list-worked-time"
    }, userValues === null || userValues === void 0 ? void 0 : userValues.unproductiveSec)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "edit-user-details-list-worked-time"
    }, userValues === null || userValues === void 0 ? void 0 : userValues.neutralSec)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "edit-user-details-list-worked-time"
    }, userValues === null || userValues === void 0 ? void 0 : userValues.breakSec)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "edit-user-details-list-worked-time"
    }, userValues === null || userValues === void 0 ? void 0 : userValues.untrackedSec)));
  }))), userDetails !== null && userDetails !== void 0 && (_userDetails$getUserD4 = userDetails.getUserData) !== null && _userDetails$getUserD4 !== void 0 && _userDetails$getUserD4.length ? /*#__PURE__*/React.createElement("div", {
    className: "edit-user-details-div-root-load-more-button"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("div", {
    className: "edit-employees-root-content-data-details-edit-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button project-management-miled-color"
  }, "You have seen all the employees")) : null), /*#__PURE__*/React.createElement(EditUserDetailsModal, {
    editUserModalShow: editUserModalShow,
    handleEditUserModalClose: handleEditUserModalClose,
    teamData: teamData,
    organisationId: organisationId,
    timeZone: timeZone,
    userSearch: userSearch,
    Link: Link,
    linkProps: linkProps,
    teamId: null,
    startDayUnix: null,
    endDayUnix: null,
    role: null,
    USER_LIMIT: null,
    activeTimeline: null,
    search: null,
    pageType: "list",
    user: user,
    timezoneFilter: timezoneFilter,
    dateFilter: dateFilter
  }));
};
export var EditUserDetailsModal = function EditUserDetailsModal(props) {
  var _editUserModalShow$us, _editUserModalShow$te, _editUserModalShow$te2, _editUserModalShow$te3, _editUserModalShow$te4, _editUserModalShow$te5, _editUserModalShow$te6, _editUserModalShow$te7, _editUserModalShow$te8, _editUserModalShow$te9, _editUserModalShow$te10, _editUserModalShow$te11, _editUserModalShow$te12, _editUserModalShow$te13, _editUserModalShow$te14, _teamUserListData$tea;
  var editUserModalShow = props.editUserModalShow,
    handleEditUserModalClose = props.handleEditUserModalClose,
    teamData = props.teamData,
    organisationId = props.organisationId,
    timeZone = props.timeZone,
    userSearch = props.userSearch,
    Link = props.Link,
    linkProps = props.linkProps,
    teamId = props.teamId,
    startDayUnix = props.startDayUnix,
    endDayUnix = props.endDayUnix,
    role = props.role,
    USER_LIMIT = props.USER_LIMIT,
    activeTimeline = props.activeTimeline,
    search = props.search,
    pageType = props.pageType,
    user = props.user,
    dateFilter = props.dateFilter,
    timezoneFilter = props.timezoneFilter,
    setEditUserModalShow = props.setEditUserModalShow;
  if (editUserModalShow == null) {
    return null;
  }
  var _useLazyQuery = useLazyQuery(TEAM_LIST_FOR_USER_QUERY, {
      variables: {
        userId: editUserModalShow === null || editUserModalShow === void 0 ? void 0 : (_editUserModalShow$us = editUserModalShow.user) === null || _editUserModalShow$us === void 0 ? void 0 : _editUserModalShow$us.userId,
        organisationId: organisationId
      },
      fetchPolicy: "network-only",
      skip: !organisationId
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getTeamList = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    teamUserListData = _useLazyQuery2$.data,
    teamUserListError = _useLazyQuery2$.error,
    teamUserListLoading = _useLazyQuery2$.loading;
  React.useEffect(function () {
    if (editUserModalShow.user.userId != null) {
      getTeamList();
    }
  }, [editUserModalShow]);

  // const [editManualStartDate, setEditManualStartDate] = React.useState(editUserModalShow?.startDate);
  // const [isEditManualDatePickerOpen, setIsEditManualDatePickerOpen] = React.useState(false);

  var _useMutation = useMutation(EDIT_USER_WORK_DETAILS_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    editUserWorkDetails = _useMutation2[0],
    editUserWorkDetailsLoading = _useMutation2[1].loading;
  var handleEditChange = React.useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values, _ref3) {
      var _editUserModalShow$us2;
      var resetForm, setFieldError, variables, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            resetForm = _ref3.resetForm, setFieldError = _ref3.setFieldError;
            variables = {
              userId: editUserModalShow === null || editUserModalShow === void 0 ? void 0 : (_editUserModalShow$us2 = editUserModalShow.user) === null || _editUserModalShow$us2 === void 0 ? void 0 : _editUserModalShow$us2.userId,
              organisationId: organisationId,
              date: editUserModalShow !== null && editUserModalShow !== void 0 && editUserModalShow.dateMS ? editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.dateMS : editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.startDate,
              clockIn: values !== null && values !== void 0 && values.clockIn ? moment(values === null || values === void 0 ? void 0 : values.clockIn).format("HH:mm") : null,
              clockOut: values !== null && values !== void 0 && values.clockOut ? moment(values === null || values === void 0 ? void 0 : values.clockOut).format("HH:mm") : null,
              totalHours: values !== null && values !== void 0 && values.totalWorkedTime ? Number(values === null || values === void 0 ? void 0 : values.totalWorkedTime) : 0,
              productiveSec: values !== null && values !== void 0 && values.productiveTime ? Number(values === null || values === void 0 ? void 0 : values.productiveTime) : 0,
              unproductiveSec: values !== null && values !== void 0 && values.unproductiveTime ? Number(values === null || values === void 0 ? void 0 : values.unproductiveTime) : 0,
              neutralSec: values !== null && values !== void 0 && values.neutralTime ? Number(values === null || values === void 0 ? void 0 : values.neutralTime) : 0,
              breakSec: values !== null && values !== void 0 && values.breakTime ? Number(values === null || values === void 0 ? void 0 : values.breakTime) : 0,
              idleSec: values !== null && values !== void 0 && values.idleTime ? Number(values === null || values === void 0 ? void 0 : values.idleTime) : 0,
              untrackedSec: values !== null && values !== void 0 && values.untrackedTime ? Number(values === null || values === void 0 ? void 0 : values.untrackedTime) : 0,
              timeZone: timeZone,
              teamId: values === null || values === void 0 ? void 0 : values.teamId,
              updatedBy: user.userId
            };
            _context.prev = 2;
            _context.next = 5;
            return editUserWorkDetails({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [pageType == "list" ? {
                query: GET_USER_DATA_QUERY,
                variables: {
                  organisationId: organisationId,
                  date: moment(editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.startDate).format("YYYY-MM-DD"),
                  timeZone: timeZone,
                  limit: LIMIT,
                  offset: 0,
                  userSearch: userSearch
                }
              } : {
                query: TIMESHEET_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: startDayUnix,
                  endDate: endDayUnix,
                  userRole: role,
                  limit: USER_LIMIT,
                  offset: (Number(activeTimeline) - 1) * Number(USER_LIMIT),
                  searchText: search,
                  timezoneFilter: timezoneFilter,
                  dateRange: dateFilter
                }
              }]
            });
          case 5:
            response = _context.sent;
            if (response && response.data && response.data.editUserWorkDetails == true) {
              toast.success("User data updated successfully!");
              resetForm();
              handleEditUserModalClose();
            } else {
              toast.error("Error Occured, try again!");
            }
            _context.next = 13;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            console.log({
              error: _context.t0
            });
            if (isRateLimited(_context.t0)) {
              // Shown under Save Changes rather than as a toast: the edit is still on
              // screen, so the reason belongs next to the button that failed.
              setFieldError("formError", rateLimitMessage(_context.t0));
            } else {
              toast.error("Error Occured, try again!");
            }
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 9]]);
    }));
    return function (_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }(), [editUserWorkDetails, editUserWorkDetailsLoading]);

  // const handleEditChangeNew = React.useCallback(
  //   async (values, { resetForm }) => {

  //     const editDate =
  //       editUserModalShow?.dateMS || editUserModalShow?.startDate;

  //     const variables = {
  //       userId: editUserModalShow?.user?.userId,
  //       organisationId,
  //       date: editDate,
  //       clockIn: values?.clockIn ? moment(values.clockIn).format("HH:mm") : null,
  //       clockOut: values?.clockOut ? moment(values.clockOut).format("HH:mm") : null,
  //       totalHours: values?.totalWorkedTime ? Number(values.totalWorkedTime) : 0,
  //       productiveSec: values?.productiveTime ? Number(values.productiveTime) : 0,
  //       unproductiveSec: values?.unproductiveTime ? Number(values.unproductiveTime) : 0,
  //       neutralSec: values?.neutralTime ? Number(values.neutralTime) : 0,
  //       breakSec: values?.breakTime ? Number(values.breakTime) : 0,
  //       idleSec: values?.idleTime ? Number(values.idleTime) : 0,
  //       untrackedSec: values?.untrackedTime ? Number(values.untrackedTime) : 0,
  //       timeZone,
  //       teamId: values?.teamId,
  //       updatedBy: user.userId,
  //     };

  //     try {

  //       const response = await editUserWorkDetails({
  //       variables,

  //       update: (cache, { data }) => {

  //         const updated = data?.editUserWorkDetails;
  //         if (!updated?.success) return;

  //         const timesheetVariables = {
  //           organisationId,
  //           teamId,
  //           startDate: startDayUnix,
  //           endDate: endDayUnix,
  //           userRole: role,
  //           limit: USER_LIMIT,
  //           offset: (Number(activeTimeline) - 1) * Number(USER_LIMIT),
  //           searchText: search,
  //           timezoneFilter,
  //           dateRange: dateFilter,
  //         };

  //         try {

  //           const existingData = cache.readQuery({
  //             query: TIMESHEET_QUERY,
  //             variables: timesheetVariables,
  //           });

  //           if (!existingData?.timesheet?.users) return;

  //           const updatedUsers = existingData.timesheet.users.map((userEntry) => {

  //             if (userEntry.user?.userId !== variables.userId) {
  //               return userEntry;
  //             }

  //             return {
  //               ...userEntry,

  //               // update summary column
  //               totalWorkedMins: updated.work,
  //               totalProductiveMins: updated.productive,
  //               totalUnproductiveMins: updated.unproductive,
  //               totalNeutralMins: updated.neutral,
  //               totalBreakMins: updated.break,
  //               totalIdleMins: updated.idle,
  //               totalUntrackedMins: updated.untrack,
  //               totalActiveMins: updated.active,

  //               days: userEntry.days.map((day) => {

  //                 if (Number(day.date) !== Number(editDate)) return day;

  //                 return {
  //                   ...day,

  //                   in: updated.clockIn
  //                     ? updated.clockIn
  //                     : day.in,

  //                   out: updated.clockOut
  //                     ? updated.clockOut
  //                     : day.out,

  //                   work: updated.work,
  //                   workInMins: updated.workInMins,

  //                   productive: updated.productive,
  //                   productiveInMins: updated.productiveInMins,

  //                   unproductive: updated.unproductive,
  //                   unproductiveInMins: updated.unproductiveInMins,

  //                   neutral: updated.neutral,
  //                   neutralInMins: updated.neutralInMins,

  //                   break: updated.break,
  //                   breakInMins: updated.breakInMins,

  //                   idle: updated.idle,
  //                   idleInMins: updated.idleInMins,

  //                   untrack: updated.untrack,
  //                   untrackInMins: updated.untrackInMins,

  //                   active: updated.active,
  //                   activeMins: updated.activeMins,

  //                   workMinsWithoutUntrack:
  //                     updated.workInMins - updated.untrackInMins,

  //                   updatedBy: updated.updatedBy,
  //                 };

  //               }),
  //             };

  //           });

  //           cache.writeQuery({
  //             query: TIMESHEET_QUERY,
  //             variables: timesheetVariables,
  //             data: {
  //               ...existingData,
  //               timesheet: {
  //                 ...existingData.timesheet,
  //                 users: updatedUsers,
  //               },
  //             },
  //           });

  //           console.log("🟣 CACHE AFTER UPDATE:", updatedUsers);

  //         } catch (err) {
  //           console.log("❌ Cache update error:", err);
  //         }

  //       },

  //       });

  //       if (response?.data?.editUserWorkDetails?.success) {
  //         toast.success("User data updated successfully!");
  //         resetForm();
  //         handleEditUserModalClose();
  //       } else {
  //         toast.error("Error occurred, try again!");
  //       } 
  //     } catch (error) {
  //       console.log("❌ MUTATION ERROR:", error);
  //       toast.error("Error occurred, try again!");
  //     }

  //   },
  //   [
  //   editUserWorkDetails,
  //   organisationId,
  //   teamId,
  //   startDayUnix,
  //   endDayUnix,
  //   role,
  //   USER_LIMIT,
  //   activeTimeline,
  //   search,
  //   timezoneFilter,
  //   dateFilter,
  //   editUserModalShow,
  //   ]
  // );

  var handleEditChangeNew = React.useCallback( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values, _ref5) {
      var _editUserModalShow$us3;
      var resetForm, setFieldError, editDate, variables, _response$data, _response$data$editUs, response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            resetForm = _ref5.resetForm, setFieldError = _ref5.setFieldError;
            editDate = (editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.dateMS) || (editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.startDate);
            variables = {
              userId: editUserModalShow === null || editUserModalShow === void 0 ? void 0 : (_editUserModalShow$us3 = editUserModalShow.user) === null || _editUserModalShow$us3 === void 0 ? void 0 : _editUserModalShow$us3.userId,
              organisationId: organisationId,
              date: editDate,
              clockIn: values !== null && values !== void 0 && values.clockIn ? moment(values.clockIn).format("HH:mm") : null,
              clockOut: values !== null && values !== void 0 && values.clockOut ? moment(values.clockOut).format("HH:mm") : null,
              totalHours: values !== null && values !== void 0 && values.totalWorkedTime ? Number(values.totalWorkedTime) : 0,
              productiveSec: values !== null && values !== void 0 && values.productiveTime ? Number(values.productiveTime) : 0,
              unproductiveSec: values !== null && values !== void 0 && values.unproductiveTime ? Number(values.unproductiveTime) : 0,
              neutralSec: values !== null && values !== void 0 && values.neutralTime ? Number(values.neutralTime) : 0,
              breakSec: values !== null && values !== void 0 && values.breakTime ? Number(values.breakTime) : 0,
              idleSec: values !== null && values !== void 0 && values.idleTime ? Number(values.idleTime) : 0,
              untrackedSec: values !== null && values !== void 0 && values.untrackedTime ? Number(values.untrackedTime) : 0,
              timeZone: timeZone,
              teamId: values === null || values === void 0 ? void 0 : values.teamId,
              updatedBy: user.userId
            };
            _context2.prev = 3;
            _context2.next = 6;
            return editUserWorkDetails({
              variables: variables,
              update: function update(cache, _ref7) {
                var data = _ref7.data;
                var updated = data === null || data === void 0 ? void 0 : data.editUserWorkDetails;
                if (!(updated !== null && updated !== void 0 && updated.success)) return;
                var timesheetVariables = {
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: startDayUnix,
                  endDate: endDayUnix,
                  userRole: role,
                  limit: USER_LIMIT,
                  offset: (Number(activeTimeline) - 1) * Number(USER_LIMIT),
                  searchText: search,
                  timezoneFilter: timezoneFilter,
                  dateRange: dateFilter
                };
                try {
                  var _existingData$timeshe;
                  var existingData = cache.readQuery({
                    query: TIMESHEET_QUERY,
                    variables: timesheetVariables
                  });
                  if (!(existingData !== null && existingData !== void 0 && (_existingData$timeshe = existingData.timesheet) !== null && _existingData$timeshe !== void 0 && _existingData$timeshe.users)) return;
                  var updatedUsers = existingData.timesheet.users.map(function (userEntry) {
                    var _userEntry$user;
                    if (((_userEntry$user = userEntry.user) === null || _userEntry$user === void 0 ? void 0 : _userEntry$user.userId) !== variables.userId) return userEntry;
                    var updatedDays = userEntry.days.map(function (day) {
                      var _day$team;
                      if (Number(day.date) !== Number(editDate)) return day;

                      // If day.team is empty (first-time entry), use mutation team directly.
                      // Otherwise merge: keep all cached teams, replace only the edited one.
                      var updatedTeam = (_day$team = day.team) !== null && _day$team !== void 0 && _day$team.length ? day.team.map(function (et) {
                        var _updated$team, _et$offlineTaskSec;
                        var mutationTeam = (_updated$team = updated.team) === null || _updated$team === void 0 ? void 0 : _updated$team.find(function (t) {
                          return t.teamId === et.teamId;
                        });
                        if (!mutationTeam) return et;
                        return _objectSpread(_objectSpread(_objectSpread({}, et), mutationTeam), {}, {
                          offlineTaskSec: (_et$offlineTaskSec = et.offlineTaskSec) !== null && _et$offlineTaskSec !== void 0 ? _et$offlineTaskSec : 0,
                          updatedBy: updated.updatedBy || et.updatedBy
                        });
                      }) : (updated.team || []).map(function (t) {
                        var _t$offlineTaskSec;
                        return _objectSpread(_objectSpread({}, t), {}, {
                          offlineTaskSec: (_t$offlineTaskSec = t.offlineTaskSec) !== null && _t$offlineTaskSec !== void 0 ? _t$offlineTaskSec : 0,
                          updatedBy: updated.updatedBy || t.updatedBy
                        });
                      });
                      var teamTotals = updatedTeam.reduce(function (acc, t) {
                        acc.work += Number(t.workedSec || 0);
                        acc.productive += Number(t.productiveSec || 0);
                        acc.unproductive += Number(t.unproductiveSec || 0);
                        acc.neutral += Number(t.neutralSec || 0);
                        acc["break"] += Number(t.breakSec || 0);
                        acc.idle += Number(t.idleSec || 0);
                        acc.untracked += Number(t.untrackedSec || 0);
                        return acc;
                      }, {
                        work: 0,
                        productive: 0,
                        unproductive: 0,
                        neutral: 0,
                        "break": 0,
                        idle: 0,
                        untracked: 0
                      });
                      var activeSec = teamTotals.work - teamTotals.idle + teamTotals.untracked;
                      return _objectSpread(_objectSpread({}, day), {}, {
                        "in": updated.clockIn || day["in"],
                        out: updated.clockOut || day.out,
                        work: convertSecToHoursAndMinutesWithTextShortForm(Number(teamTotals.work) * 60),
                        workInMins: teamTotals.work,
                        productive: convertSecToHoursAndMinutesWithTextShortForm(Number(teamTotals.productive) * 60),
                        productiveInMins: teamTotals.productive,
                        unproductive: convertSecToHoursAndMinutesWithTextShortForm(Number(teamTotals.unproductive) * 60),
                        unproductiveInMins: teamTotals.unproductive,
                        neutral: convertSecToHoursAndMinutesWithTextShortForm(Number(teamTotals.neutral) * 60),
                        neutralInMins: teamTotals.neutral,
                        "break": convertSecToHoursAndMinutesWithTextShortForm(Number(teamTotals["break"]) * 60),
                        breakInMins: teamTotals["break"],
                        idle: convertSecToHoursAndMinutesWithTextShortForm(Number(teamTotals.idle) * 60),
                        idleInMins: teamTotals.idle,
                        untrack: convertSecToHoursAndMinutesWithTextShortForm(Number(teamTotals.untracked) * 60),
                        untrackInMins: teamTotals.untracked,
                        activeMins: activeSec,
                        active: convertSecToHoursAndMinutesWithTextShortForm(activeSec * 60),
                        workMinsWithoutUntrack: teamTotals.work - teamTotals.untracked,
                        updatedBy: updated.updatedBy,
                        team: updatedTeam
                      });
                    });
                    var totals = updatedDays.reduce(function (acc, d) {
                      acc.work += d.workInMins || 0;
                      acc.productive += d.productiveInMins || 0;
                      acc.unproductive += d.unproductiveInMins || 0;
                      acc.neutral += d.neutralInMins || 0;
                      acc["break"] += d.breakInMins || 0;
                      acc.idle += d.idleInMins || 0;
                      acc.untracked += d.untrackInMins || 0;
                      acc.active += d.activeMins || 0;
                      return acc;
                    }, {
                      work: 0,
                      productive: 0,
                      unproductive: 0,
                      neutral: 0,
                      "break": 0,
                      idle: 0,
                      untracked: 0,
                      active: 0
                    });
                    return _objectSpread(_objectSpread({}, userEntry), {}, {
                      days: updatedDays,
                      totalWorkedMins: convertSecToHoursAndMinutesWithTextShortForm(Number(totals.work) * 60),
                      totalProductiveMins: convertSecToHoursAndMinutesWithTextShortForm(Number(totals.productive) * 60),
                      totalUnproductiveMins: convertSecToHoursAndMinutesWithTextShortForm(Number(totals.unproductive) * 60),
                      totalNeutralMins: convertSecToHoursAndMinutesWithTextShortForm(Number(totals.neutral) * 60),
                      totalBreakMins: convertSecToHoursAndMinutesWithTextShortForm(Number(totals["break"]) * 60),
                      totalIdleMins: convertSecToHoursAndMinutesWithTextShortForm(Number(totals.idle) * 60),
                      totalUntrackedMins: convertSecToHoursAndMinutesWithTextShortForm(Number(totals.untracked) * 60),
                      totalActiveMins: convertSecToHoursAndMinutesWithTextShortForm(Number(totals.active) * 60)
                    });
                  });
                  cache.writeQuery({
                    query: TIMESHEET_QUERY,
                    variables: timesheetVariables,
                    data: _objectSpread(_objectSpread({}, existingData), {}, {
                      timesheet: _objectSpread(_objectSpread({}, existingData.timesheet), {}, {
                        users: updatedUsers
                      })
                    })
                  });
                } catch (err) {
                  console.log(" Cache update error:", err);
                }
              }
            });
          case 6:
            response = _context2.sent;
            if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && (_response$data$editUs = _response$data.editUserWorkDetails) !== null && _response$data$editUs !== void 0 && _response$data$editUs.success) {
              toast.success("User data updated successfully!");
              resetForm();
              handleEditUserModalClose();
            } else {
              toast.error("Error occurred, try again!");
            }
            _context2.next = 14;
            break;
          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](3);
            console.log(" MUTATION ERROR:", _context2.t0);
            if (isRateLimited(_context2.t0)) {
              setFieldError("formError", rateLimitMessage(_context2.t0));
            } else {
              toast.error("Error occurred, try again!");
            }
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 10]]);
    }));
    return function (_x3, _x4) {
      return _ref6.apply(this, arguments);
    };
  }(), [editUserWorkDetails, organisationId, teamId, startDayUnix, endDayUnix, role, USER_LIMIT, activeTimeline, search, timezoneFilter, dateFilter, editUserModalShow]);
  var endOnChange = function endOnChange(value, setFieldValue, type) {
    if (value !== null) {
      var data = value.format(formats);
      var arrData = data.split(" ");
      var finalTime = data;
      if (arrData[1] == "pm") {
        var hours = Number(data.match(/^(\d+)/)[1]);
        var minutes = Number(data.match(/:(\d+)/)[1]);
        var AMPM = data.match(/\s(.*)$/)[1];
        if (AMPM == "pm" && hours < 12) hours = hours + 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        finalTime = sHours + ":" + sMinutes;
      }
      setFieldValue(type, value);
    } else {
      setFieldValue(type, undefined);
    }
  };

  // const handleChange = (e) => {
  //   setIsEditManualDatePickerOpen(!isEditManualDatePickerOpen);
  //   setEditManualStartDate(e);
  // };

  var formats = "h:mm a";

  // let yestedayDate = findYesterdayDate();

  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleEditUserModalClose,
    centered: true,
    backdrop: "static",
    size: "md"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "manage-team-modal-title"
  }, "Edit Timesheet")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "edit-user-details-modal-body"
  }, /*#__PURE__*/React.createElement(Formik, {
    key: editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.dateMS,
    initialValues: {
      clockIn: editUserModalShow !== null && editUserModalShow !== void 0 && editUserModalShow.clockInTime && (editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.clockInTime) != "-" && (editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.clockInTime) != "Working On" ? moment(Number(editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.clockInTime)) : undefined,
      clockOut: editUserModalShow !== null && editUserModalShow !== void 0 && editUserModalShow.clockOutTime && (editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.clockOutTime) != "-" && (editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.clockOutTime) != "Working On" ? moment(Number(editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.clockOutTime)) : undefined,
      totalWorkedTime: editUserModalShow !== null && editUserModalShow !== void 0 && (_editUserModalShow$te = editUserModalShow.team) !== null && _editUserModalShow$te !== void 0 && _editUserModalShow$te.length && editUserModalShow !== null && editUserModalShow !== void 0 && (_editUserModalShow$te2 = editUserModalShow.team[0]) !== null && _editUserModalShow$te2 !== void 0 && _editUserModalShow$te2.workedSec ? Number(editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.team[0].workedSec) : " ",
      idleTime: editUserModalShow !== null && editUserModalShow !== void 0 && (_editUserModalShow$te3 = editUserModalShow.team) !== null && _editUserModalShow$te3 !== void 0 && _editUserModalShow$te3.length && editUserModalShow !== null && editUserModalShow !== void 0 && (_editUserModalShow$te4 = editUserModalShow.team[0]) !== null && _editUserModalShow$te4 !== void 0 && _editUserModalShow$te4.idleSec ? Number(editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.team[0].idleSec) : " ",
      productiveTime: editUserModalShow !== null && editUserModalShow !== void 0 && (_editUserModalShow$te5 = editUserModalShow.team) !== null && _editUserModalShow$te5 !== void 0 && _editUserModalShow$te5.length && editUserModalShow !== null && editUserModalShow !== void 0 && (_editUserModalShow$te6 = editUserModalShow.team[0]) !== null && _editUserModalShow$te6 !== void 0 && _editUserModalShow$te6.productiveSec ? Number(editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.team[0].productiveSec) : " ",
      unproductiveTime: editUserModalShow !== null && editUserModalShow !== void 0 && (_editUserModalShow$te7 = editUserModalShow.team) !== null && _editUserModalShow$te7 !== void 0 && _editUserModalShow$te7.length && editUserModalShow !== null && editUserModalShow !== void 0 && (_editUserModalShow$te8 = editUserModalShow.team[0]) !== null && _editUserModalShow$te8 !== void 0 && _editUserModalShow$te8.unproductiveSec ? Number(editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.team[0].unproductiveSec) : " ",
      neutralTime: editUserModalShow !== null && editUserModalShow !== void 0 && (_editUserModalShow$te9 = editUserModalShow.team) !== null && _editUserModalShow$te9 !== void 0 && _editUserModalShow$te9.length && editUserModalShow !== null && editUserModalShow !== void 0 && (_editUserModalShow$te10 = editUserModalShow.team[0]) !== null && _editUserModalShow$te10 !== void 0 && _editUserModalShow$te10.neutralSec ? Number(editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.team[0].neutralSec) : " ",
      breakTime: editUserModalShow !== null && editUserModalShow !== void 0 && (_editUserModalShow$te11 = editUserModalShow.team) !== null && _editUserModalShow$te11 !== void 0 && _editUserModalShow$te11.length && editUserModalShow !== null && editUserModalShow !== void 0 && (_editUserModalShow$te12 = editUserModalShow.team[0]) !== null && _editUserModalShow$te12 !== void 0 && _editUserModalShow$te12.breakSec ? Number(editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.team[0].breakSec) : " ",
      untrackedTime: editUserModalShow !== null && editUserModalShow !== void 0 && (_editUserModalShow$te13 = editUserModalShow.team) !== null && _editUserModalShow$te13 !== void 0 && _editUserModalShow$te13.length && editUserModalShow !== null && editUserModalShow !== void 0 && editUserModalShow.team[0].untrackedSec ? Number(editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.team[0].untrackedSec) : " ",
      teamId: editUserModalShow !== null && editUserModalShow !== void 0 && editUserModalShow.team && editUserModalShow !== null && editUserModalShow !== void 0 && (_editUserModalShow$te14 = editUserModalShow.team) !== null && _editUserModalShow$te14 !== void 0 && _editUserModalShow$te14.length ? editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.team[0].teamId : teamUserListData === null || teamUserListData === void 0 ? void 0 : (_teamUserListData$tea = teamUserListData.teamListForUser[0]) === null || _teamUserListData$tea === void 0 ? void 0 : _teamUserListData$tea.teamId
    },
    enableReinitialize: true,
    validationSchema: UserSchema,
    onSubmit: pageType == "list" ? handleEditChange : handleEditChangeNew
  }, function (_ref8) {
    var _editUserModalShow$us4, _editUserModalShow$us5, _editUserModalShow$us6, _editUserModalShow$us7, _editUserModalShow$us8, _editUserModalShow$us9;
    var setFieldValue = _ref8.setFieldValue,
      values = _ref8.values,
      errors = _ref8.errors;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      md: 6,
      lg: 6
    }, /*#__PURE__*/React.createElement("div", {
      className: "edit-user-details-modal-text-label-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "edit-user-details-modal-text-label-name-edit"
    }, "Name"), /*#__PURE__*/React.createElement("div", {
      className: "edit-employees-root-content-data-details-avatar"
    }, editUserModalShow !== null && editUserModalShow !== void 0 && (_editUserModalShow$us4 = editUserModalShow.user) !== null && _editUserModalShow$us4 !== void 0 && _editUserModalShow$us4.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "employee-edit-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: editUserModalShow === null || editUserModalShow === void 0 ? void 0 : (_editUserModalShow$us5 = editUserModalShow.user) === null || _editUserModalShow$us5 === void 0 ? void 0 : _editUserModalShow$us5.profileUrl,
      className: "team-card-avatar-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "edit-employees-root-content-data-details-avatar-circle edit-employees-root-content-data-details-edit-avatar-circle text-white"
    }, editUserModalShow === null || editUserModalShow === void 0 ? void 0 : (_editUserModalShow$us6 = editUserModalShow.user) === null || _editUserModalShow$us6 === void 0 ? void 0 : _editUserModalShow$us6.displayName.charAt(0)), /*#__PURE__*/React.createElement("div", {
      className: "edit-employees-root-content-data-details-name-data edit-employees-root-content-data-details-edit-name-data"
    }, " ", /*#__PURE__*/React.createElement(Link, _extends({}, _defineProperty({}, linkProps, "/personal-statistics/".concat(editUserModalShow === null || editUserModalShow === void 0 ? void 0 : (_editUserModalShow$us7 = editUserModalShow.user) === null || _editUserModalShow$us7 === void 0 ? void 0 : _editUserModalShow$us7.uniqueUrl)), {
      key: "employee-".concat(editUserModalShow === null || editUserModalShow === void 0 ? void 0 : (_editUserModalShow$us8 = editUserModalShow.user) === null || _editUserModalShow$us8 === void 0 ? void 0 : _editUserModalShow$us8.uniqueUrl)
    }), editUserModalShow === null || editUserModalShow === void 0 ? void 0 : (_editUserModalShow$us9 = editUserModalShow.user) === null || _editUserModalShow$us9 === void 0 ? void 0 : _editUserModalShow$us9.displayName), " ")))), /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      md: 6,
      lg: 6
    }, /*#__PURE__*/React.createElement("div", {
      className: "edit-user-details-modal-text-label-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "edit-user-details-modal-text-label-name"
    }, "Date"), /*#__PURE__*/React.createElement("div", {
      className: "edit-user-details-modal-text-label-value"
    }, editUserModalShow === null || editUserModalShow === void 0 ? void 0 : editUserModalShow.startDate)))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      md: 6,
      lg: 6
    }, /*#__PURE__*/React.createElement(Field, {
      name: "clockIn"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "edit-user-details-modal-label-name"
      }, "Clock In"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "ClockInTime",
        value: values.clockIn,
        onChange: function onChange(e) {
          endOnChange(e, setFieldValue, "clockIn");
        },
        placeholder: "Clock In Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        inputReadOnly: true,
        className: "edit-user-details-list-modal-clock-in-time edit-user-details-list-modal-time edit-user-details-list-modal-input"
      })));
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      md: 6,
      lg: 6
    }, /*#__PURE__*/React.createElement(Field, {
      name: "clockOut"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "edit-user-details-modal-label-name"
      }, "Clock Out"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "ClockOutTime",
        value: values.clockOut,
        onChange: function onChange(e) {
          endOnChange(e, setFieldValue, "clockOut");
        },
        placeholder: "Clock Out Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        inputReadOnly: true,
        className: "edit-user-details-list-clock-out-time edit-user-details-list-modal-time edit-user-details-list-modal-input"
      })));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      md: 6,
      lg: 6
    }, /*#__PURE__*/React.createElement(Field, {
      name: "teamId"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "edit-user-details-list-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "edit-user-details-list-modal-label-name"
      }, "Select Team"), teamUserListLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(FormControl, _extends({
        as: "select",
        defaultValue: ""
      }, field, {
        className: "edit-user-details-list-modal-input",
        onChange: function onChange(e) {
          var _editUserModalShow$te15;
          var selectTeamId = e.target.value;
          setFieldValue("teamId", selectTeamId);
          var teamWorkedDetails = editUserModalShow === null || editUserModalShow === void 0 ? void 0 : (_editUserModalShow$te15 = editUserModalShow.team) === null || _editUserModalShow$te15 === void 0 ? void 0 : _editUserModalShow$te15.find(function (team) {
            return team.teamId === selectTeamId;
          });
          setFieldValue("totalWorkedTime", teamWorkedDetails ? teamWorkedDetails.workedSec : " ");
          setFieldValue("idleTime", teamWorkedDetails ? teamWorkedDetails.idleSec : " ");
          setFieldValue("productiveTime", teamWorkedDetails ? teamWorkedDetails.productiveSec : " ");
          setFieldValue("unproductiveTime", teamWorkedDetails ? teamWorkedDetails.unproductiveSec : " ");
          setFieldValue("neutralTime", teamWorkedDetails ? teamWorkedDetails.neutralSec : " ");
          setFieldValue("breakTime", teamWorkedDetails ? teamWorkedDetails.breakSec : " ");
          setFieldValue("untrackedTime", teamWorkedDetails ? teamWorkedDetails.untrackedSec : " ");
        }
      }), /*#__PURE__*/React.createElement("option", {
        value: ""
      }, "Select Team"), teamUserListData === null || teamUserListData === void 0 ? void 0 : teamUserListData.teamListForUser.map(function (team) {
        return /*#__PURE__*/React.createElement("option", {
          value: team.teamId
        }, team.teamName);
      })), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error edit-user-details-list-modal-team-error edit-user-details-list-modal-select-team-error"
      }, meta.error) : null);
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      md: 6,
      lg: 6
    }, /*#__PURE__*/React.createElement(Field, {
      name: "totalWorkedTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "edit-user-details-list-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "edit-user-details-list-modal-label-name"
      }, "Total Time (Mins)", " ", /*#__PURE__*/React.createElement("span", {
        className: "timesheet-exclude-text"
      }, "(Excluding Untracked Time) ")), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "Number",
        placeholder: "Enter the value in minutes",
        className: "edit-user-details-list-modal-input",
        min: "0",
        required: true,
        onKeyPress: function onKeyPress(event) {
          if (event.charCode < 48) {
            event.preventDefault();
          }
        }
      }, field)));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      md: 6,
      lg: 6
    }, /*#__PURE__*/React.createElement(Field, {
      name: "idleTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "edit-user-details-list-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "edit-user-details-list-modal-label-name"
      }, "Idle (Mins)"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "Number",
        placeholder: "Enter the value in minutes",
        className: "edit-user-details-list-modal-input",
        min: "0",
        onKeyPress: function onKeyPress(event) {
          if (event.charCode < 48) {
            event.preventDefault();
          }
        }
      }, field)));
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      md: 6,
      lg: 6
    }, /*#__PURE__*/React.createElement(Field, {
      name: "productiveTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "edit-user-details-list-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "edit-user-details-list-modal-label-name"
      }, "Productive (Mins)"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "Number",
        placeholder: "Enter the value in minutes",
        className: "edit-user-details-list-modal-input",
        min: "0",
        onKeyPress: function onKeyPress(event) {
          if (event.charCode < 48) {
            event.preventDefault();
          }
        }
      }, field)));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      md: 6,
      lg: 6
    }, /*#__PURE__*/React.createElement(Field, {
      name: "unproductiveTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "edit-user-details-list-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "edit-user-details-list-modal-label-name"
      }, "Unproductive (Mins)"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "Number",
        placeholder: "Enter the value in minutes",
        className: "edit-user-details-list-modal-input",
        min: "0",
        onKeyPress: function onKeyPress(event) {
          if (event.charCode < 48) {
            event.preventDefault();
          }
        }
      }, field)));
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      md: 6,
      lg: 6
    }, /*#__PURE__*/React.createElement(Field, {
      name: "neutralTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "edit-user-details-list-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "edit-user-details-list-modal-label-name"
      }, "Neutral (Mins)"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "Number",
        placeholder: "Enter the value in minutes",
        className: "edit-user-details-list-modal-input",
        min: "0",
        onKeyPress: function onKeyPress(event) {
          if (event.charCode < 48) {
            event.preventDefault();
          }
        }
      }, field)));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      md: 6,
      lg: 6
    }, /*#__PURE__*/React.createElement(Field, {
      name: "breakTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "edit-user-details-list-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "edit-user-details-list-modal-label-name"
      }, "Break (Mins)"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "Number",
        placeholder: "Enter the value in minutes",
        className: "edit-user-details-list-modal-input",
        min: "0",
        onKeyPress: function onKeyPress(event) {
          if (event.charCode < 48) {
            event.preventDefault();
          }
        }
      }, field)));
    })), " ", /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      md: 6,
      lg: 6
    }, /*#__PURE__*/React.createElement(Field, {
      name: "untrackedTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "edit-user-details-list-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "edit-user-details-list-modal-label-name"
      }, "Untracked (Mins)"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "Number",
        placeholder: "Enter the value in minutes",
        className: "edit-user-details-list-modal-input",
        min: "0",
        onKeyPress: function onKeyPress(event) {
          if (event.charCode < 48) {
            event.preventDefault();
          }
        }
      }, field)));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "edit-user-details-list-modal-button text-center"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "edit-user-details-list-modal-save-button",
      type: "submit",
      disabled: editUserWorkDetailsLoading
    }, editUserWorkDetailsLoading ? "Loading..." : "Save Changes"), /*#__PURE__*/React.createElement(Button, {
      variant: "outline-secondary",
      onClick: handleEditUserModalClose,
      className: "edit-user-details-list-modal-close-button"
    }, "Cancel"), errors.formError ? /*#__PURE__*/React.createElement("div", {
      className: "edit-user-details-list-modal-form-error"
    }, errors.formError) : null))))));
  })));
};
export default EditTimesheet;